import { ModCard } from "./ModCard";
import type { Database } from "~/types/database";

// 定义从数据库查询返回的mod类型
type ModFromDB = Database['public']['Tables']['mods']['Row'] & {
  author: Database['public']['Tables']['users']['Row']
  category: Database['public']['Tables']['categories']['Row'] | null
  mod_images?: Database['public']['Tables']['mod_images']['Row'][]
  mod_tags?: (Database['public']['Tables']['mod_tags']['Row'] & {
    tag: Database['public']['Tables']['tags']['Row']
  })[]
}

interface ModGridProps {
  mods: ModFromDB[];
  title?: string;
  className?: string;
}

export function ModGrid({ mods, title, className = "" }: ModGridProps) {
  if (mods.length === 0) {
    return (
      <div className={`text-center py-12 ${className}`}>
        <p className="text-muted-foreground">No mods found.</p>
      </div>
    );
  }

  return (
    <div className={className}>
      {title && (
        <h2 className="text-2xl font-bold mb-6">{title}</h2>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {mods.map((mod) => (
          <ModCard key={mod.id} mod={mod} />
        ))}
      </div>
    </div>
  );
} 